import RouteCollection from 'zoomforth_zf/models/route.collection.js';

import routesByPageStore from './routes-by-page.js';

var singleton;

const init = function(data, opts) {

  singleton = new RouteCollection(data, opts);

  routesByPageStore.init(singleton);

  return singleton;
};
  
const get = function() {
  if (!singleton) {
    throw new Error('You must call `init` on appglobal singleton before calling `get`');
  }
  return singleton;
};


export { get, init };
export default { get, init };
